'use server'

import { apiRequest, ApiResponse } from '../request'

export type SidebarTheme = 'dark' | 'light'

export interface SidebarThemeResponse {
    theme: SidebarTheme
}

export async function getSidebarTheme(): Promise<
    ApiResponse<SidebarThemeResponse>
> {
    return apiRequest('utils/settings/user/sidebar-theme', {})
}

export async function updateSidebarTheme(
    theme: SidebarTheme
): Promise<ApiResponse<SidebarThemeResponse>> {
    return apiRequest(
        'utils/settings/user/sidebar-theme',
        { data: { theme } },
        'patch'
    )
}
